// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PreferenceModal_wrapper__imXd1","content":"PreferenceModal_content__2-2hd","btn__grp":"PreferenceModal_btn__grp__3Dm4w"};